type FormControl = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement

/** The form control an event was fired on, or null when it came from something else. */
export function event_control(event: Event): FormControl | null {
    const target = event.target
    return target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement
        ? target
        : null
}

/** The value of the form control an event was fired on; '' when it wasn't fired on one. */
export function event_value(event: Event): string {
    return event_control(event)?.value ?? ''
}

/** The input element an event was fired on, for `checked` and `files`, which only inputs have. */
export function event_input(event: Event): HTMLInputElement | null {
    return event.target instanceof HTMLInputElement ? event.target : null
}

/** `node` as an HTMLElement, or null when it isn't one (an SVG element, a text node, nothing yet). */
export function html_element(node: unknown): HTMLElement | null {
    return node instanceof HTMLElement ? node : null
}
